import { cartDetailsFragment } from '../queries/get-cart-query'

const cartDiscountUpdateMutation = /* GraphQL */ `
  mutation cartDiscountUpdate(
    $cartId: ID!
    $discountCodes: [String!]
  ) {
    cartDiscountCodeUpdate(cartId: $cartId, discountCodes: $discountCodes
    ) {
      userErrors {
        code
        field
        message
      }
      cart {
        ...cartDetails
      }
    }
  }

  ${cartDetailsFragment}
`
export default cartDiscountUpdateMutation
